/* eslint-disable import/prefer-default-export */
import React from 'react';
import {
  Card,
  Typography,
  Box,
  Grid,
  CardActionArea,
  CardMedia,
  Skeleton,
  Theme,
  useMediaQuery,
} from '@mui/material';
import { SectionProps } from './types';
import useCloudinaryUrl from '../../hooks/use-trip-photo';

export const Section = ({
  icon,
  title,
  subtitle,
  children,
  sx = {},
}: SectionProps) => (
  <Box
    display="flex"
    sx={{
      paddingTop: {
        desktop: 9.5,
        mobile: 6,
      },
      paddingBottom: {
        desktop: 9,
        mobile: 6.5,
      },
      ...sx,
    }}
  >
    <Grid container spacing={6}>
      <Grid item xs={12} sm={12} md={12} lg={3}>
        {icon}
        {title}
        {subtitle}
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={9}>
        {children}
      </Grid>
    </Grid>
  </Box>
);

export const SectionTitle = ({ title }: { title: string }) => (
  <Typography variant="h2" sx={{ marginBottom: '6px' }}>
    {title}
  </Typography>
);

export const SectionSubtitle = ({ subtitle }: { subtitle: string }) => (
  <Typography variant="body1" sx={{ color: '#4A5152' }}>
    {subtitle}
  </Typography>
);

export const DESKTOP_IMAGE_HEIGHT = 384;
export const MOBILE_IMAGE_HEIGHT = 230;

const mobileDimension = { width: 161, height: 228 };
const desktopDimension = { width: 278, height: 382 };

export const TripRequestImage = ({ photoId }: { photoId: string }) => {
  const isDesktopDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('desktop'));
  const [cloudinaryUrl, isLoading, error] = useCloudinaryUrl(photoId, isDesktopDown ? mobileDimension : desktopDimension);

  return (
    <Card>
      <CardActionArea>
        {isLoading || error ? (
          <Skeleton
            variant="rectangular"
            sx={{
              width: '100%',
              height: {
                desktop: DESKTOP_IMAGE_HEIGHT,
                mobile: MOBILE_IMAGE_HEIGHT,
              },
            }}
          />
        ) : (

          <CardMedia
            sx={{
              height: {
                desktop: DESKTOP_IMAGE_HEIGHT,
                mobile: MOBILE_IMAGE_HEIGHT,
              },
            }}
            image={cloudinaryUrl}
          />

        )}
      </CardActionArea>
    </Card>
  );
};
